import React from 'react';

import Link from '@mui/material/Link';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { useStylesCommon } from 'components/scheduleDisplay/styles';
import { getTeamRoute } from 'config/router/utils';

interface TeamLinkProps {
  className?: string;
  tournamentId: string;
  name: string;
  participantId: string;
}

export const TeamLink: React.FC<React.PropsWithChildren<TeamLinkProps>> = React.memo(
  ({ className, name, tournamentId, participantId }) => {
    const { classes } = useStylesCommon(false);
    const { t } = useTranslation();

    return (
      <Link
        classes={{ root: classes.participantName }}
        className={cx(className)}
        component={RouterLink}
        to={tournamentId ? getTeamRoute(tournamentId, participantId) : ''}
        underline="hover"
      >
        {name || t('notApplicable')}
      </Link>
    );
  },
);

export default TeamLink;
